import PlateSheet from '../PlateSheet'
import RegMark from '../ui/RegMark'

/**
 * Where the process is used, beside what it has made: one section, the
 * mirror of the overview. The text column (the application areas as a
 * legend list with orange registration-mark bullets, then the page's two
 * figures as a title block) sits on the right and stays in view while the
 * examples — the part plates — run down the left.
 *
 * @param {{
 *   lang: 'tr' | 'en' | 'de',
 *   title: string,
 *   items: string[],
 *   stats: Array<{ label: string, value: string }>,
 *   examplesTitle: string,
 *   images: string[],
 * }} props
 */
export default function ServiceApplications({ lang, title, items, stats, examplesTitle, images }) {
  return (
    <section className="sp-applications" aria-labelledby="sp-applications-title">
      <div className="container sp-applications-grid">
        <div className="sp-applications-text">
          <h2 id="sp-applications-title">{title}</h2>
          <ul className="sp-app-list">
            {items.map((item) => (
              <li key={item}>
                <RegMark className="reg sp-app-mark" size={14} />
                <span>{item}</span>
              </li>
            ))}
          </ul>
          <table className="spec sp-applications-spec">
            <tbody>
              {stats.map((stat) => (
                <tr key={stat.label}>
                  <th scope="row">{stat.label}</th>
                  <td className="tabular">{stat.value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="sp-examples">
          <h3 className="sp-minor-title sp-examples-title" id="sp-examples-title">
            {examplesTitle}
          </h3>
          <PlateSheet
            images={images}
            lang={lang}
            label={examplesTitle}
            labelledBy="sp-examples-title"
            layout="column"
          />
        </div>
      </div>
    </section>
  )
}
